/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { priceStyles } from "@stoneage/Overrides/Widgets/ProductDetails/ProductDetailsPrice";
import { productPriceSavingsMessageStyles } from "@warthog/Overrides/Components/ProductPriceSavingsMessage";
import { css } from "styled-components";

priceStyles.savingPriceStyles = {
    ...productPriceSavingsMessageStyles,
    wrapper: {
        css: css``,
    },
    label: {
        size: 15,
        lineHeight: "26px",
        color: "text.main",
        weight: "bold",
    },
    price: {
        size: 15,
        color: "text.main",
        lineHeight: "26px",
        css: css`
            font-weight: 800;
        `,
    },
};

priceStyles.productPrice = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            line-height: 20px;
            padding-right: 5px;
        `,
    },
    price: {
        priceText: {
            size: 15,
            lineHeight: "24px",
            css: css`
                font-weight: 800;
            `,
        },
        unitOfMeasureText: { size: 26 },
    },
};

priceStyles.replacementInventory = {
    size: "12px",
    lineHeight: "26px",
    css: css`
        display: flex;
        align-items: center;
        white-space: nowrap;
        &.not-pdp {
            line-height: 21px;
        }
    `,
};
